export default __webpack_public_path__ + "static/media/Marker_Pen.418ddf33.svg";